var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,2 h5 v20 h-5 v-19 h1 v18 h3 v-18 h-4 v-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2 h6 v20 h-6 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2 h5 v20 h-5 v-19 h1 v18 h3 v-18 h-4 v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColumn);
export default __webpack_public_path__ + "static/media/icon_column.07ed49a5a91e4eac04e714e5123ac913.svg";
export { ForwardRef as ReactComponent };